import { render } from "./CoverContent.vue?vue&type=template&id=fbd91fe2"
import script from "./CoverContent.vue?vue&type=script&lang=js"
export * from "./CoverContent.vue?vue&type=script&lang=js"

import "./CoverContent.vue?vue&type=style&index=0&id=fbd91fe2&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__